/**
 * Asynchronously loads the component for AdminPlacementDashboard
 */

import { lazyLoad } from 'utils/loadable';

export const AdminPlacementDashboard = lazyLoad(
  () => import('./PlacementDashboard'),
  module => module.AdminPlacementDashboard,
);

export const AdminViewDrive = lazyLoad(
  () => import('./ViewDrive'),
  module => module.AdminViewDrive,
);